import React, { useEffect, useRef, useState } from "react";
import styles from "./customers.module.scss";
import { Add, Numbers, UploadFile } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import { GenCustomTable } from "../../components/customComponents/genCustomTable/GenCustomTable";
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SearchInput from "../../components/uiComponents/searchInput/SearchInput";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import OutlinedButton from "../../components/customComponents/outlinedButton/OutlinedButton";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
import { connect, useDispatch } from "react-redux";
import { getAllCustomer, getCustomerByIdResponse } from "../../store/actions";
import EditIcon from "@mui/icons-material/Edit";
const columns = [
  {
    id: 1,
    label: "S.NO",
    minWidth: 120,
    align: "center",
  },

  {
    id: 3,
    label: "FULL NAME",
    minWidth: 170,
    align: "center",
  },
  {
    id: 4,
    label: "PHONE NUMBER",
    minWidth: 170,
    align: "center",
  },
  {
    id: 5,
    label: "EMAIL",
    minWidth: 170,
    align: "center",
  },
  // {
  //   id: 6,
  //   label: "ACTION",
  //   minWidth: 170,
  //   align: "center",
  // },
];

const Customers = ({ customers = [] }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState(customers);
  const [searched, setSearched] = useState("");

  useEffect(() => {
    dispatch(getAllCustomer());
  }, [dispatch]);

  useEffect(() => {
    setFilteredData(customers);
  }, [customers]);

  const handleEdit = (item = {}) => {
    dispatch(getCustomerByIdResponse(item));
    navigate("/customers/editCustomer");
  };

  const handleNavigate = (item = {}) => {
    dispatch(getCustomerByIdResponse(item));
    navigate("/customers/CustomerOrderDetails");
  };

  const getStructuredRows = (data = []) => {
    return data?.map((item, idx) => ({
      id: item?.id,
      rColumns: [
        idx + 1,
        <Button
          variant="outlined"
          className={styles.ovalButtonOut}
          disableRipple
          onClick={() => handleNavigate(item)}
        >
          {item?.fullName || "NA"}
        </Button>,
        item?.phoneNumber,
        item?.email,
        // <div className={styles.imgtable} onClick={() => handleEdit(item)}>
        //   <EditIcon color="primary" /> EDIT
        // </div>,
      ],
    }));
  };
  console.log("customers", customers)

  const handleSearch = (value) => {
    setSearched(value);

    const searchText = (value || "").trim().toLowerCase();
    if (!searchText) {
      setFilteredData(customers);
      return;
    }

    const filtered = customers.filter((item) =>
      [item?.fullName, item?.phoneNumber, item?.email].some((field) =>
        String(field || "")
          .toLowerCase()
          .includes(searchText)
      )
    );
    setFilteredData(filtered);
  };

  return (
    <div className={styles.container}>
      <StatusCard leftContent="CUSTOMERS" />
      <div className={styles.wrapper}>
        <div className={styles.topWrapper}>
          <div className={styles.top}></div>
          <div className={styles.search}>
            {/* <SearchInput
              placeholder="Search"
              onSearch={handleSearch} // uses the prop your component expects
            /> */}
            {/* <CustomButton
              title="Add"
              txtClr="#FFFFFF"
              background="black"
              width="141px"
              height="48px"
              borderRadius="12px"
              onClick={() => handleNavigate()}
            /> */}
          </div>
        </div>
        <div className={styles.bottom}>
          <GenCustomTable
            columns={columns}
            rows={getStructuredRows(filteredData)}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    customers: state?.customer?.customers,
  };
};

export default connect(mapStateToProps, null)(Customers);
